import Navbar from "./components/navbar/Navbar";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import AddPurchase from "./pages/add_purchase/AddPurchase";
import Orderlist from "./pages/orderlist/orderlist";
import Profile from "./pages/profile/profile";
import NotFound from "./pages/notfound/NotFound";
import Registerbwc from "./pages/bwcregister/bwcregister";
import React, { useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter,
  Route,
  Routes,
  Link
} from "react-router-dom";

const App = () => {

  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
          <Route path="/register-warranty/" element={<Home />}/>
          <Route path="/register-warranty/bwc-register-warranty/" element={<Registerbwc />}/>
          <Route path="/register-warranty/order_list/:phone_cust" element={<Orderlist />}/>
          <Route path="/register-warranty/login" element={<Login />}/>
          <Route path="/register-warranty/register/:phone_cust" element={<Register />} />
          <Route path="/register-warranty/add_products/:phone_cust" element={<AddPurchase />}/>
          <Route path="/register-warranty/profile/:phone_cust" element={<Profile />}/>
          <Route path="/register-warranty/*" element={<NotFound />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
